var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftSide-container"},[_c('div',{staticClass:"main"},_vm._l((_vm.liData),function(item){return _c('ul',[_c('router-link',{staticClass:"link",attrs:{"to":item.href,"tag":"a"}},[_c('li',[_vm._v(_vm._s(item.title))])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac94f48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftSide.vue
// module id = null
// module chunks = 